<template>
  <div class="form-group">
    <label :for="field.type + '_' + field.id" v-html="title"></label>
    <input
      :id="field.type + '_' + field.id"
      ref="file"
      type="file"
      class="form-control-file"
      :class="{ 'is-invalid': errorMessage }"
      @change="onFileChange"
    />
    <transition name="fade">
      <div v-if="errorMessage" class="invalid-feedback">
        {{ errorMessage }}
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  name: "File",
  props: ["field"],
  data() {
    return {
      errorMessage: "",
      mimeTypes: {
        image: ["image/jpeg", "image/png"],
        document: [
          "application/pdf",
          "application/msword",
          "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          "application/vnd.ms-excel",
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          "application/octet-stream",
        ],
        archive: ["application/zip", "application/vnd.rar"],
      },
    };
  },
  computed: {
    title() {
      if (!this.field.isRequired) return this.field.title;
      return this.field.title + " " + '<span class="required">*</span>';
    },
  },
  created() {
    this.$set(this.field, "file", "");
  },
  methods: {
    onFileChange(e) {
      this.errorMessage = "";

      if (
        this.mimeTypes[this.field.value].indexOf(e.target.files[0].type) === -1
      ) {
        this.errorMessage = this.$t(
          "This file type does not support for this field"
        );
        this.$refs.file.value = "";
        this.field.file = "";
        return;
      }

      if (e.target.files[0].size > 2 * 1024 * 1024) {
        this.errorMessage = this.$t("Upload file less than 2MB");
        this.$refs.file.value = "";
        this.field.file = "";
        return;
      }

      this.field.file = e.target.files[0];
    },
  },
};
</script>
